
import BottomSheetModalWrapper from '@Components/modals/modal-wrapper/bottom-sheet-modal-wrapper';

import SelectGroup from '@app/components/group/select-group';


const SelectGroupFullModalView = () => {
    return (
        <BottomSheetModalWrapper>
            <SelectGroup />
        </BottomSheetModalWrapper>
    );
};
export default SelectGroupFullModalView;